function getEmailValidationErrorMessage(status) {
  switch (status) {
    case 'FailureBlacklist':
      return 'Unfortunately, we can’t accept this email address due to specific email providers blocking our emails. Please use an alternative email address to make sure this client will be able to receive future communications from us.';
    case 'FailureDomain':
    case 'FailureZeroBounce':
    default:
      return 'Invalid email';
  }
}

export { getEmailValidationErrorMessage };
